const e = "_flexContainer_yqp1b_1", n = {
  flexContainer: e
};
export {
  n as default,
  e as flexContainer
};
